import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Stats() {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-211">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-212">
        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-213">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-214">
            +500
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-215">
            personas ya lo usan
          </div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-216">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-217">
            6
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-218">Tomos listos</div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center" data-id="element-219">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-220">
            6
          </div>
          <div className="text-sm text-gray-400 font-medium" data-id="element-221">
            Bonos incluidos
          </div>
        </div>

        <div className="bg-brand-card border border-brand-green/10 rounded-2xl p-6 text-center flex flex-col items-center justify-center" data-id="element-222">
          <div className="text-3xl md:text-4xl font-black text-brand-green mb-1" data-id="element-223">
            4.9/5
          </div>
          <div className="flex text-brand-gold" data-id="element-224">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-225" />)}
          </div>
        </div>
      </motion.div>
    </section>;
}